export const mobileStyles = {
  goal: {
    border: '1px solid #e6eaee',
    boxShadow: '0px 0px 3px rgba(0, 0, 0, 0.03)',
    borderRadius: '4px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '15px',
  },
  goalHeader: {
    borderBottom: '1px solid #e6e8f1',
  },
  goalHeaderTitle: {
    color: '#354052',
    fontFamily: 'Rubik, serif',
    fontWeight: 500,
    fontSize: '18px',
    margin: '25px 20px 16.5px',
  },
  goalBody: {
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
  },
  goalMain: {
    borderBottom: '1px solid #c5d0de',
    marginBottom: '20px',
    paddingBottom: '20px',
    display: 'flex',
    flexDirection: 'column',
  },
  goalName: {
    fontFamily: 'Rubik, serif',
    fontWeight: 'normal',
    fontSize: '18px',
    color: '#354052',
    margin: 0,
  },
  goalInfoWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '12px',
    marginTop: '4px',
  },
  goalValue: {
    margin: 0,
    color: '#208cd7',
  },
  currentValue: {
    margin: 0,
    color: '#354052',
  },
  goalValueH1: {
    fontFamily: 'Rubik, serif',
    display: 'inline',
    fontWeight: 'normal',
    fontSize: '45px',
    margin: 0,
  },
  goalValueSpan: {
    fontSize: '24px',
  },
  formWrapper: {
    display: 'flex',
    width: '100%',
  },
  textField: {
    flex: 1,
    '& input': {
      fontFamily: 'Rubik, serif',
      fontSize: '12px',
      padding: '10.5px',
      '&::-webkit-inner-spin-button': {
        display: 'none',
      },
      MozAppearance: 'textfield',
    },
  },
  formButton: {
    marginLeft: '10px',
    color: 'white',
    width: '75px',
    height: '35px',
    borderRadius: '4px',
    background: '#2ea1f8',
    flexShrink: 0,
    '&:hover': {
      background: '#1a8de0',
    },
  },
  formattedDate: {
    margin: '13px 0 0',
    fontFamily: 'Rubik, serif',
    fontWeight: 'normal',
    fontSize: '12px',
    color: '#354052',
    textAlign: 'left',
  },
  impressions: {
    display: 'flex',
    flexDirection: 'column',
  },
};
